module.exports = "/*\r\n    STYLE GUIDES\r\n*/\n"